module.exports = __webpack_public_path__ + "img/icon-tag-light-blue.5ebe24f1.svg";